import React, { FC } from 'react';
import { XIcon } from '@heroicons/react/solid';

import { isArray } from 'lodash';
import {
	Button, ButtonAppearance, Dropdown, MiddleEllipsis,
} from '@aleph/shared-components';
import { motion } from 'framer-motion';
import { IColumnEditor } from '@aleph/supergrid';

const KeywordColumnEditor: FC<IColumnEditor<string[]>> = (params) => {
	const { value, setValue } = params;

	return (
		<div
			className="flex flex-col gap-[8px] p-[8px]"
		>
			{
				isArray(value)
				&& value.map((word, idx) => (
					<motion.div
						key={idx}
						className="flex flex-col gap-[8px]"
						initial={{ y: 100, opacity: 0 }}
						animate={{ y: 0, opacity: 1 }}
						transition={{
							bounce: 0.2, duration: 0.1, delay: 0.1,
						}}
					>
						<div className="bg-[#666666] flex flex-row text-wrap items-center justify-between p-[8px] text-white rounded-lg text-[14px]">
							<div className='truncate hover:text-clip w-[95%]'>
								<MiddleEllipsis>
									<Dropdown
										disabled={!word}
										triggerControl={
											({ openDropdown, closeDropdown, isOpen }) => (
												<Button
													title={word}
													appearance={ButtonAppearance.GHOST}
													disabled={!word}
													onClick={() => (isOpen ? closeDropdown() : openDropdown())}
												/>
											)
										}
									>
										{word}
									</Dropdown>
								</MiddleEllipsis>
							</div>

							<div
								className="cursor-pointer justify-self-end w-[5%]"
								onClick={() => setValue(value.filter((currValue) => currValue !== word))}
							>
								<XIcon
									height={14}
									width={14}
								/>
							</div>
						</div>
					</motion.div>
				))
			}
		</div>
	);
};

export default KeywordColumnEditor;
